{
  "modes": {
    "imp": {"size": 1},
    "acc": {"size": 1},
    "imm": {"size": 2, "group_nibble": 1},
    "zp": {"size": 2, "group_nibble": 2},
    "abs": {"size": 3, "group_nibble": 3},
    "ind": {"size": 3},
    "zpx": {"size": 2, "group_nibble": 4},
    "absx": {"size": 3, "group_nibble": 5},
    "absy": {"size": 3, "group_nibble": 6},
    "rel": {"size": 2, "group_nibble": 7},
    "zpy": {"size": 2, "group_nibble": 8},
    "indx": {"size": 2, "group_nibble": 9},
    "indy": {"size": 2, "group_nibble": 10},
    "indy_pre": {"size": 2, "group_nibble": 11},
    "indx_post": {"size": 2, "group_nibble": 12}
  },
  "groups": [
    {"group_nibble": 1, "mnemonic": "LDA", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 2, "mnemonic": "STA", "kind": "store", "modes": ["zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 3, "mnemonic": "LDX", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 4, "mnemonic": "STX", "kind": "store", "modes": ["zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 5, "mnemonic": "LDY", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 6, "mnemonic": "STY", "kind": "store", "modes": ["zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 7, "mnemonic": "AND", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 8, "mnemonic": "ORA", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 9, "mnemonic": "EOR", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 10, "mnemonic": "ADC", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 11, "mnemonic": "SBC", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]},
    {"group_nibble": 12, "mnemonic": "CMP", "kind": "load", "modes": ["imm", "zp", "abs", "zpx", "zpy", "absx", "absy", "indx", "indy", "indy_pre", "indx_post"]}
  ],
  "specials": [
    {"code": 0, "mnemonic": "INC", "mode": "acc"},
    {"code": 6, "mnemonic": "INC", "mode": "absy"},
    {"code": 7, "mnemonic": "INC", "mode": "zp"},
    {"code": 8, "mnemonic": "INC", "mode": "zpy"},
    {"code": 9, "mnemonic": "INC", "mode": "indx"},
    {"code": 10, "mnemonic": "INC", "mode": "indy"},
    {"code": 11, "mnemonic": "INC", "mode": "indy_pre"},
    {"code": 12, "mnemonic": "INC", "mode": "indx_post"},
    {"code": 13, "mnemonic": "INC", "mode": "abs"},
    {"code": 14, "mnemonic": "INC", "mode": "zpx"},
    {"code": 15, "mnemonic": "INC", "mode": "absx"},
    {"code": 16, "mnemonic": "ASL", "mode": "acc"},
    {"code": 23, "mnemonic": "ASL", "mode": "zp"},
    {"code": 29, "mnemonic": "ASL", "mode": "abs"},
    {"code": 30, "mnemonic": "ASL", "mode": "zpx"},
    {"code": 31, "mnemonic": "ASL", "mode": "absx"},
    {"code": 32, "mnemonic": "LSR", "mode": "acc"},
    {"code": 39, "mnemonic": "LSR", "mode": "zp"},
    {"code": 45, "mnemonic": "LSR", "mode": "abs"},
    {"code": 46, "mnemonic": "LSR", "mode": "zpx"},
    {"code": 47, "mnemonic": "LSR", "mode": "absx"},
    {"code": 48, "mnemonic": "ROL", "mode": "acc"},
    {"code": 55, "mnemonic": "ROL", "mode": "zp"},
    {"code": 61, "mnemonic": "ROL", "mode": "abs"},
    {"code": 62, "mnemonic": "ROL", "mode": "zpx"},
    {"code": 63, "mnemonic": "ROL", "mode": "absx"},
    {"code": 64, "mnemonic": "ROR", "mode": "acc"},
    {"code": 71, "mnemonic": "ROR", "mode": "zp"},
    {"code": 77, "mnemonic": "ROR", "mode": "abs"},
    {"code": 78, "mnemonic": "ROR", "mode": "zpx"},
    {"code": 79, "mnemonic": "ROR", "mode": "absx"},
    {"code": 80, "mnemonic": "ASR", "mode": "acc"},
    {"code": 87, "mnemonic": "ASR", "mode": "zp"},
    {"code": 93, "mnemonic": "ASR", "mode": "abs"},
    {"code": 94, "mnemonic": "ASR", "mode": "zpx"},
    {"code": 95, "mnemonic": "ASR", "mode": "absx"},
    {"code": 96, "mnemonic": "DEC", "mode": "acc"},
    {"code": 103, "mnemonic": "DEC", "mode": "zp"},
    {"code": 109, "mnemonic": "DEC", "mode": "abs"},
    {"code": 110, "mnemonic": "DEC", "mode": "zpx"},
    {"code": 111, "mnemonic": "DEC", "mode": "absx"},
    {"code": 112, "mnemonic": "DEC", "mode": "absy"},
    {"code": 119, "mnemonic": "DEC", "mode": "zpy"},
    {"code": 125, "mnemonic": "DEC", "mode": "indx"},
    {"code": 126, "mnemonic": "DEC", "mode": "indy"},
    {"code": 127, "mnemonic": "DEC", "mode": "indy_pre"},
    {"code": 128, "mnemonic": "DEC", "mode": "indx_post"},
    {"code": 208, "mnemonic": "BEQ", "mode": "rel"},
    {"code": 209, "mnemonic": "BNE", "mode": "rel"},
    {"code": 210, "mnemonic": "BCS", "mode": "rel"},
    {"code": 211, "mnemonic": "BCC", "mode": "rel"},
    {"code": 212, "mnemonic": "BMI", "mode": "rel"},
    {"code": 213, "mnemonic": "BPL", "mode": "rel"},
    {"code": 214, "mnemonic": "BVS", "mode": "rel"},
    {"code": 215, "mnemonic": "BVC", "mode": "rel"},
    {"code": 216, "mnemonic": "JEQ", "mode": "abs"},
    {"code": 217, "mnemonic": "JNE", "mode": "abs"},
    {"code": 218, "mnemonic": "JCS", "mode": "abs"},
    {"code": 219, "mnemonic": "JCC", "mode": "abs"},
    {"code": 220, "mnemonic": "JMI", "mode": "abs"},
    {"code": 221, "mnemonic": "JPL", "mode": "abs"},
    {"code": 222, "mnemonic": "JVS", "mode": "abs"},
    {"code": 223, "mnemonic": "JVC", "mode": "abs"},
    {"code": 224, "mnemonic": "JMP", "mode": "abs"},
    {"code": 225, "mnemonic": "JSR", "mode": "abs"},
    {"code": 226, "mnemonic": "RTS", "mode": "imp"},
    {"code": 227, "mnemonic": "RTI", "mode": "imp"},
    {"code": 228, "mnemonic": "JMP", "mode": "ind"},
    {"code": 232, "mnemonic": "PHA", "mode": "imp"},
    {"code": 233, "mnemonic": "PLA", "mode": "imp"},
    {"code": 234, "mnemonic": "PHP", "mode": "imp"},
    {"code": 235, "mnemonic": "PLP", "mode": "imp"},
    {"code": 236, "mnemonic": "CLC", "mode": "imp"},
    {"code": 237, "mnemonic": "CLI", "mode": "imp"},
    {"code": 238, "mnemonic": "SEI", "mode": "imp"},
    {"code": 239, "mnemonic": "SEC", "mode": "imp"},
    {"code": 240, "mnemonic": "NOP", "mode": "imp"},
    {"code": 241, "mnemonic": "HLT", "mode": "imp"},
    {"code": 242, "mnemonic": "BRK", "mode": "imm"},
    {"code": 243, "mnemonic": "TSX", "mode": "imp"},
    {"code": 244, "mnemonic": "TXS", "mode": "imp"},
    {"code": 245, "mnemonic": "TSY", "mode": "imp"},
    {"code": 246, "mnemonic": "TYS", "mode": "imp"},
    {"code": 247, "mnemonic": "TAX", "mode": "imp"},
    {"code": 248, "mnemonic": "TXA", "mode": "imp"},
    {"code": 249, "mnemonic": "TAY", "mode": "imp"},
    {"code": 250, "mnemonic": "TYA", "mode": "imp"},
    {"code": 251, "mnemonic": "INX", "mode": "imp"},
    {"code": 252, "mnemonic": "DEX", "mode": "imp"},
    {"code": 253, "mnemonic": "INY", "mode": "imp"},
    {"code": 254, "mnemonic": "DEY", "mode": "imp"}
  ]
}
